import { DialogProps, Drawer } from '@mui/material';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, PropsWithChildren, type JSX } from 'react';

import './SideDrawer.sass';

type Props = {
  className?: string;
  isOpen: boolean;
  showCloseControl?: boolean;
  onClose?: () => void;
  disableBackdropClick?: boolean;
};

const SideDrawer: FC<PropsWithChildren<Props>> = ({
  className,
  isOpen,
  showCloseControl = true,
  onClose,
  children,
  disableBackdropClick = false,
}: PropsWithChildren<Props>): JSX.Element | null => {
  const onCloseInternal: DialogProps['onClose'] = (event, reason) => {
    if (!disableBackdropClick || reason !== 'backdropClick') {
      onClose?.();
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      className={`side-drawer !z-side-drawer ${className ? className : ''}`}
      onClose={onCloseInternal}
    >
      {showCloseControl && (
        <div className="close-control" onClick={onClose}>
          <UntitledIcon name="x.3" />
        </div>
      )}
      <div className="side-drawer-inner">
        <div className="side-drawer-content-wrapper mb-8">{children}</div>
      </div>
    </Drawer>
  );
};
export default SideDrawer;
